import qs from "qs";

// DM and DMX share some routes but have different titles
const PLATFORM_TITLES = {
  DynaMed: {
    "/browse/drug-monograph": "Drugs A-Z",
    "/browse/drug-interactions": "Drug Interactions"
  },
  DynaMedex: {
    "/browse/drug-monograph": "General Drug Monographs",
    "/browse/drug-interactions": "Merative Micromedex® Drug Interactions"
  }
};

const PAGE_TITLES = {
  "/": "Home",
  // DM/X
  "/results": "Search results for: %s",
  "/results/algorithms": "Search algorithms for: %s",
  "/results/videos": "Search videos for: %s",
  "/results/images": "Search images for: %s",
  "/results/calculators": "Search calculators for: %s",
  "/alerts": "Alerts",
  "/browse/drug-neonatal": "NeoFax® & Pediatrics Drug Monographs",
  "/browse/drug-pediatric": "NeoFax® & Pediatrics Drug Monographs",
  "/browse/iv-compatibility": "Merative® Micromedex IV Compatibility",
  "/browse/chemo-regimens/diseases": "Chemotherapy Regimens by Disease",
  "/browse/chemo-regimens/agents": "Chemotherapy Regimens by Agent",
  // DHE
  "/continuing-education": "About Continuing Education",
  "/ce/available": "Available Continuing Education",
  "/ce/claimed": "Claimed Continuing Education",
  "/search": "Search results for: %s",
  "/search/videos": "Search videos for: %s",
  "/search/images": "Search images for: %s",
  "/search/patient-handouts": "Search patient handouts for: %s",
  "/search/leadership": "Search leadership for: %s",
  "/browse/patient-handouts/diseases-and-conditions":
    "Diseases & Conditions Patient Handouts",
  "/browse/patient-handouts/procedures-and-tests":
    "Procedures & Tests Patient Handouts",
  "/browse/patient-handouts/health-and-wellness":
    "Health & Wellness Patient Handouts",
  "/browse/patient-handouts/discharge-instructions":
    "Discharge Instructions Patient Handouts",
  "/admin/hidden": "Hidden Content Items - Content Admin",
  "/admin/hidden-content-sets": "Hidden Content Sets - Content Admin",
  "/admin/notes": "Workplace Notes - Content Admin",
  "/admin/skills": "Workplace Skills - Content Admin",
  "/admin/analytics": "Analytics - Admin",
  "/editorial-leadership": "Editorial Leadership",
  "/systemcheck": "System Check",
  // DD
  "/tools": "Tools"
};

const capitalize = (title) => {
  return title
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default (path, search, platform = "") => {
  if (!path) {
    return null;
  }

  // Handle trailing slashes
  if (path.endsWith("/") && path.length > 1) {
    path = path.slice(0, -1);
  }

  // Check if path is shared
  let title = PLATFORM_TITLES[platform]?.[path] ?? PAGE_TITLES[path];

  // Search results
  if (title?.includes("%s")) {
    const { q, browseTopic } = qs.parse(search, { ignoreQueryPrefix: true });
    const searchTerm = q || browseTopic?.split("%7C").pop();
    title = searchTerm ? title.replace("%s", searchTerm) : "";
  }

  // Chemo regimens by disease or agent
  if (path.startsWith("/browse/chemo-regimens/by")) {
    const { disease, agent } = qs.parse(search, { ignoreQueryPrefix: true });
    title = disease ?? agent;
  }

  // Browse routes
  if (!title && path.startsWith("/browse/")) {
    title = capitalize(path.split("/").pop().replace(/-/g, " "));
    if (path.startsWith("/browse/specialties/")) {
      title += " - Specialties";
    } else if (path.startsWith("/browse/patient-information/")) {
      title += " - Patient Information";
    }
  }

  return title;
};
